/*
 * Copyright (c) 2024. Bluemate B.V.
 */

import React, {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {SearchVolumeData} from '../../util/interfaces';

import Chart from 'react-apexcharts';

interface Props {
    searchVolumes: Array<SearchVolumeData>;
    width?: number | string;
    height?: number | string;
}

export default function SearchVolumeHeatChart(props: Props) {
    const {t} = useTranslation();
    const {searchVolumes, width, height} = props;
    const [series, options] = useMemo(() => {
        const nlPeriods: Record<string, number> = {};
        const bePeriods: Record<string, number> = {};
        for (const searchVolume of searchVolumes) {
            for (const periodData of searchVolume.periods) {
                const {period, BE, NL} = periodData;
                if (!Object.hasOwn(nlPeriods, period)) nlPeriods[period] = 0;
                if (!bePeriods[period]) bePeriods[period] = 0;
                nlPeriods[period] += NL;
                bePeriods[period] += BE;
            }
        }
        const series = [
            {
                name: t('searchVolume.country.be', 'België'),
                data: Object.entries(bePeriods).map(([period, value]: [string, number]) => ({x: period, y: value}))
            },
            {
                name: t('searchVolume.country.nl', 'Nederland'),
                data: Object.entries(nlPeriods).map(([period, value]: [string, number]) => ({x: period, y: value}))
            }
        ];
        const options = {
            chart: {
                toolbar: {show: false}
            },
            colors: ['#ed2939', '#ffa501'],
            dataLabels: {enabled: false},
            plotOptions: {
                heatmap: {
                    distributed: true
                }
            }
        };
        return [series, options];
    }, [searchVolumes]);

    return (
        <div className='search-volume-heat-chart'>
            <Chart options={options} series={series} type='heatmap' width={width} height={height} />
        </div>
    );
}
